import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';


import InputText from '../elements/InputText';
import DropDownSelection from '../elements/DropDownSelection';

import store from '../../helpers/store';
import appConfig from '../../config/env';
import { httpRequest } from '../../helpers/httpService';
import helpers from '../../helpers/helpers';


function SearchBar({viewer, search_key, search_filter, setSearchKey, setFilter, setLoading, sendRequest, clearSearch, handleSearch}){
    const api_url = appConfig.apiUrl;
    const user_permissions = helpers.getPermissions()
    const [category_list, setCategories] = useState([]);
    const [type_list, setTypes] = useState([]);
    const [filter_types, setFilterType] = useState(store.client_search_filters);

    // Search
    // const [search_key, setSearchKey] = useState('');
    const [input_type, setInputType] = useState('text');
    const [input_status, setInputStatus] = useState('');
    // const [search_filter, setFilter] = useState('title');

    useEffect(() => {
        getCategories()
        getTypes()

        if(user_permissions.includes('view-dashboard-events')) {
            setFilterType(store.admin_search_filters)
        }
    }, []);

    useEffect(() => {
        if(search_filter == 'date'){
            setInputType('date')
            return;
        }
        
        setSearchKey('')
        setInputStatus('')
        setInputType('search')
    }, [search_filter]);

    function getCategories() {
        const url = api_url + '/admin/categories';

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setCategories(res);
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function getTypes() {
        const url = api_url + '/admin/types';

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setTypes(res);
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function handleFocus(e){
        setInputStatus('')
    }

    function searchBtn(e){
        setInputStatus('')

        if(!search_key) {
            setInputStatus('border-danger')

            Swal.fire({
              title: "Error!",
              text: 'Please provide search value.',
              icon: "error",
              confirmButtonText: "OK",
            });
        }

        handleSearch()
    }
    
    const displaySearchField = (status = 'border-danger') =>  {
        if(search_filter === 'category'){
            return <DropDownSelection
                        tagClass={"form-select border-end-0 border-0 border-bottom " + status}
                        name={'search_filter'} 
                        placeholder='Select Category'
                        value={search_key}  
                        onChange={e => setSearchKey(e.target.value)}
                        optionList={category_list}
                        optionProps ={{value:'id', label:'category_name'}}
                        origin="category"
                        onFocus={handleFocus}
                    />
        }
        else if(search_filter === 'type'){
            return <DropDownSelection
                        tagClass={"form-select border-end-0 border-0 border-bottom " + status}
                        name={'search_filter'} 
                        placeholder='Select Type'
                        value={search_key}  
                        onChange={e => setSearchKey(e.target.value)}
                        optionList={type_list}
                        optionProps ={{'value':'id', 'label':'type_name'}}
                        origin="type"
                        onFocus={handleFocus}
                    />
        }
        else if(search_filter === 'status'){
            return <DropDownSelection
                        tagClass={"form-select border-end-0 border-0 border-bottom " + status}
                        name={'search_filter'} 
                        placeholder='Select Status'
                        value={search_key}  
                        onChange={e => setSearchKey(e.target.value)}
                        optionList={store.event_status}
                        optionProps ={{value:'id', label:'name'}}
                        origin="status"
                        onFocus={handleFocus}
                    />
        }
        else{
            return <InputText
                        id="search_key" 
                        name="search_key" 
                        value={search_key}   
                        tagClass={"form-control border-end-0 border-0 border-bottom " + status}
                        onChange={e => setSearchKey(e.target.value)}
                        placeholder="Enter your search here..."
                        type={input_type}
                        onFocus={handleFocus}
                    />
        }
    };
    
    return (
        <div className="card filter-dashboard p-4">
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <h6 className="looking">What are you looking for?</h6>
                <div className="row mt-2">
                  <div className="input-group">
                    {displaySearchField(input_status)}

                    <span className="input-group-append">
                      <button type="button" className="cancelbtn" onClick={searchBtn}>Search</button>
                      <button type="button" className="cancelbtn ms-2" onClick={clearSearch}>Clear</button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <h6 className="looking">Filter By</h6>
                <div className="row mt-2">
                  <div className="input-group mt-4">
                    <DropDownSelection
                        tagClass="form-select border-end-0 border-0 border-bottom"
                        name={'search_filter'} 
                        placeholder='Select Filters'
                        value={search_filter}  
                        onChange={e => setFilter(e.target.value)}
                        optionList={filter_types}
                        optionProps ={{value:'id', label:'name'}}
                        origin="filters"
                    />

                    <span className="input-group-append">
                      <button className="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border-0 ms-n5" type="button">
                        <i className="fa fa-filter" />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}

export default SearchBar;